import { Dtos } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { contractSuretyCarriersQueryKey } from "../account.keys";

export const useAdminGetCarrierPreviews = () => {
	const { get } = useRequest();

	const url = "/v2/admin/carriers/previews";
	const { data, error, isLoading } = useQuery({
		queryKey: contractSuretyCarriersQueryKey(),
		queryFn: async () => await get<Dtos.CarrierPreview.Get.Response[]>(url),
		retry: 0,
	});

	return {
		allCarriers: data,
		allCarriersError: error,
		allCarriersIsLoading: isLoading,
	};
};
